// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioButton-Icon_cls1__gZzLZ","cls2":"VeloRadioButton-Icon_cls2__WFohg VeloRadioButton-Icon_cls1__gZzLZ"};